import {useEntityChannels} from '../../../hooks/useEntityChannels'

export const useGroupChannels = (groupId?: string | number) => useEntityChannels('group', groupId)
